import { APIFactory } from '../api/api.factory'
import SETTINGS from '../settings'
const UsersApi = APIFactory.get('users')

// Simple caching.
var userIsAdmin = false
var userIsAdminLoaded = false

export default {
    async isUserAdmin() {
        if (!userIsAdminLoaded) {
            const { data } = await UsersApi.getUserRoles()
            userIsAdminLoaded = true;
            if (data) {
                userIsAdmin = data.includes(SETTINGS.ROLES.ADMIN)
            }
        }

        return userIsAdmin
    },
    async getUsers() {
        const { data } = await UsersApi.getUsers();
        return data;
    },
    async getUser(id) {
        const { data } = await UsersApi.getUser(id);
        return data;
    }
}